import { JcUtils } from '../utils/JcUtils';
import React from 'react';
import { JcButton, JcButtonProps, JcButtonType } from './button/JcButton';


export interface JcClickableTextProps extends Omit<JcButtonProps, "children" | "buttonType" | "size"> {
  readonly onClick: () => void;
  readonly selected?: boolean;
  readonly label: string;
}


export const JcClickableText: React.FunctionComponent<JcClickableTextProps> = (props: JcClickableTextProps) => {

  const commonProps = JcUtils.commonProps(props, ["jc-clickable-text"]);
  const { label, ...buttonProps } = JcUtils.otherProps(props);

  return <JcButton {...commonProps} {...buttonProps} buttonType={JcButtonType.GHOST}>
    {label}
  </JcButton>
}